export default __webpack_public_path__ + "assets/fun.1622f2.png";